import CardSection from '../sections/CardSection';
import SelectField from '../form/SelectField';
import InputField  from '../form/InputField';

export default function LicenseSection({ 
    data, 
    licencias,
    onChange, 
    errors 
}) {
    const tipoLicenciasOptions = Array.isArray(licencias)
        ? licencias.slice(3).map(item => ({
            value: item.codigo,
            label: item.descripcion
        }))
        : [];

    // Obtener fecha actual en formato "YYYY-MM-DD"
    const today = new Date().toISOString().split('T')[0];

    // Generar opciones de años desde 1950 hasta el año actual
    const currentYear = new Date().getFullYear();
    const yearOptions = [];
    for (let year = currentYear; year >= 1950; year--) {
        yearOptions.push({
            value: year.toString(),
            label: year.toString()
        });
    }

    return (
        <CardSection icon="drive_eta" title="Información de Licencia">
            <div className="row">
                <div className="col-md-6">
                    <SelectField
                        id="tipoLicencia"
                        label="Tipo de Licencia"
                        options={tipoLicenciasOptions}
                        required
                        value={data.tipoLicencia}
                        onChange={onChange}
                        error={errors.tipoLicencia}
                    />
                </div>
                <div className="col-md-6">
                    <InputField
                        id="numeroLicencia"
                        label="Número de Licencia"
                        placeholder="Ingrese número"
                        required
                        value={data.numeroLicencia}
                        onChange={onChange}
                        error={errors.numeroLicencia}
                    />
                </div>
                <div className="col-md-6">
                    <InputField
                        id="fechaVencimientoLicencia"
                        label="Vencimiento Licencia"
                        type="date"
                        min={today} 
                        required
                        value={data.fechaVencimientoLicencia}
                        onChange={onChange}
                        onKeyDown={e => e.preventDefault()}
                        onPaste={e => e.preventDefault()}
                        error={errors.fechaVencimientoLicencia}
                    />
                </div>
                <div className="col-md-6">
                    <SelectField
                        id="anioInicioConductor"
                        label="Año de Inicio como Conductor"
                        options={yearOptions}
                        required
                        value={data.anioInicioConductor || ''}
                        onChange={onChange}
                        error={errors?.anioInicioConductor}
                        isSearchable={true}
                    />
                </div>
            </div>
        </CardSection>
    );
}
